
import React from 'react';
import PropTypes from 'prop-types';
import { useMedia } from 'the-platform';
import { Flex, Box } from 'rebass';
import { Scroll } from 'react-fns';
import { sizes } from '../styles/theme';

const DetailNavOuter = ({ isFromTellAStory, isFromEdit, height, footerSx = {}, ...props }) => {
  const isDesktop = useMedia({ minWidth: `${sizes.desktop}px` });

  return (<Box
    sx={{
      display: ['none', 'none', 'flex'],
      ...footerSx
    }}>
    <Scroll>
      {({ y }) => (
        <Flex
          justifyContent="center"
          alignItems="center"
          sx={{
            width: '100%',
            background: '#fff',
            boxShadow: y ? '0 0 12px rgba(0, 0, 0, 0.25)' : 'none',
            zIndex: 999,
            height,
            maxWidth: (isDesktop && !isFromTellAStory) ? 'calc(100vw - 270px)' : '100%',
            position: 'fixed',
            borderBottom: '1px solid rgba(100, 116, 139, 0.30)',
            background: '#fff',
            top: ['unset', 'unset', 'unset', 0],
            bottom: [0, 0, 0, 'unset'],
            // marginBottom: -height,
            transition: '.3s ease all',
          }}
        >
          <Flex
            // style={{ maxWidth: 1200, position: 'absolute', width: '100%' }}
            sx={{
              width: '100%',
            }}
            py={1}
            m="0 auto"
            as="nav"
            px={[2, 2, 6]}
            {...props}
          />
        </Flex>
      )}
    </Scroll>
  </Box>
  );
};
DetailNavOuter.propTypes = {
  height: PropTypes.number,
};

DetailNavOuter.defaultProps = {
  height: 60,
};
export default DetailNavOuter;
